import { SchemaFormFactory } from 'formvuelate';
import VeeValidatePlugin from '@formvuelate/plugin-vee-validate';

const SchemaFormWithValidation = SchemaFormFactory([
	VeeValidatePlugin({
		mapProps(validation) {
			return { validation };
		},
	}),
]);

export default SchemaFormWithValidation;
